<template>
  <!-- 导航开始 -->
  <div class='commonRecruimentTrace' :class="{scrollHide: isShowTraceStoreBox}" ref="scrollBox">
<!--    跟进列表-->
    <div>
      <div v-for="app in data" :key="app.id" class="timeline-item green" :date-is="app.addtimeStr">
        <span class="title"><a href="javascript:void(0);">{{app.adduser}}</a> 📢 日常维护</span>
        <div class="huifu">
          {{app.contents}}
        </div>
      </div>
    </div>
<!--    状态-->
    <div>
      <div v-if='isLoading' class='dynamicMessage'>
        <i class='iconfont icon-jiazai xuanzhuan'></i>
      </div>
      <div v-if='isNodata' class='dynamicMessage'>
        — 没有更多了 —
      </div>
      <div v-if='isError' class='dynamicMessage'>
        — 请求失败 —
      </div>
    </div>
<!--    添加跟进-->
    <div v-if="isShowTraceStoreBox" class="traceStoreBoxModel">
      <div class="traceStoreBox">
        <div class="textareaBox mb-3">
          <textarea class="form-control" aria-label="With textarea" v-model="contentVal"></textarea>
        </div>
        <div class="anniuBox">
          <button type="button" @click="isShowTraceStoreBox=false" class="btn btn-secondary btn-round">取消</button>
          <button type="button" class="btn btn-success btn-round" @click="storeFun()">
            <i v-if="isTraceLoading" class='iconfont icon-jiazai xuanzhuan'></i>
            跟进
          </button>
        </div>
      </div>
    </div>
<!--    添加按钮-->
    <span v-if="!isShowTraceStoreBox" @click="isShowTraceStoreBox=true" class="tianjia btn btn-success btn-round">添加</span>
    <div class="searchLoadingBox" v-if="isSearchLoading">
      <span>
        <i class='iconfont icon-jiazai xuanzhuan'></i>
      </span>
    </div>
  </div>
  <!-- 导航结束 -->
</template>

<script>
import resultCommons from '@/util/resultcommons';
import { EventBus } from '@/util/eventBus';

export default {
  name: 'commonRecruimentTrace',
  props: ['token', 'parentInitResumeFun'],
  data() {
    return {
      isTraceLoading: false,
      // 是否显示跟进表单
      isShowTraceStoreBox: false,
      // 跟进内容
      contentVal: '',
      // 分页
      data: [], // 数据队列
      allPage: 1, // 总页数
      page: 1, // 当前页数
      is_empty: false, // 是否为空数据(没有任何数据)
      isNodata: false, // 没有更多了
      isLoading: false, // 是否请求中
      isError: false, // 请求失败
      // 加载中
      isSearchLoading: true,
    };
  },
  computed: {
    whereObj() {
      return { page: this.page, token: this.token };
    },
  },
  methods: {
    storeFun() {
      // 处理中
      this.isTraceLoading = true;
      // 遮罩
      EventBus.$emit('globalZhezhaoBoxFun', true);
      // 处理参数
      const parms = {
        token: this.token,
        contents: this.contentVal,
      };
      resultCommons.apiResumetracestore(this, { token: this.token, contents: this.contentVal }).then((ob) => {
        if (ob.state === 200) {
          this.$refs.scrollBox.scrollTop = 0;
          // 更新队列
          this.initData(true);
          // 清空
          this.contentVal = '';
          this.$message.showMsgBox({ type: 'success', content: ob.message });
        } else {
          // 提示框
          this.$message.showMsgBox({ type: 'warning', content: ob.message });
        }
        // 处理结束
        this.isTraceLoading = false;
        // 跟进模态框
        this.isShowTraceStoreBox = false;
        // 遮罩
        EventBus.$emit('globalZhezhaoBoxFun', false);
      });
      console.log(parms);
    },
    // 状态切换
    loadingFun(bool) {
      if (bool === 1) {
        // 加载中
        this.isNodata = false;
        this.isError = false;
        this.isLoading = true;
      } else if (bool === 2) {
        // 关闭所有
        this.isNodata = false;
        this.isError = false;
        this.isLoading = false;
      } else if (bool === 3) {
        // 没有更多了
        this.isNodata = true;
        this.isError = false;
        this.isLoading = false;
      } else {
        // 请求失败了
        this.isNodata = false;
        this.isError = true;
        this.isLoading = false;
      }
    },
    initData(reload = false) {
      if (reload) {
        this.allPage = 1;
        this.page = 1;
        this.is_empty = false; // 是否为空数据(没有任何数据)
        this.isNodata = false; // 没有更多了
        this.isLoading = false; // 是否请求中
        this.isError = false; // 请求失败
      }
      return resultCommons.apiResumetrace(this, this.whereObj, reload).then((ob) => {});
    },
    scroll(that, node) {
      node.onscroll = () => {
        // 距离底部200px时加载一次
        const bottomOfWindow = node.scrollHeight - node.scrollTop - node.clientHeight <= 150;
        console.log(bottomOfWindow);
        // 距离200像素时 & 可以请求时 & 页码小于等于最大页码时 & !没有更多时 & !空数据时
        if (bottomOfWindow && that.isLoading === false && !that.isNodata && !that.isError && !that.is_empty) {
          this.initData();
        }
      };
    },
  },
  components: {
  },
  created() {
  },
  mounted() {
    this.isSearchLoading = true;
    // 创建事件
    this.scroll(this, this.$refs.scrollBox);
    // 初始化
    this.initData().then((app) => {
      this.isSearchLoading = false;
    });
  },
  destroyed() {
  },
};
</script>

<style scoped lang='less'>
.commonRecruimentTrace{
  flex: 1;
  overflow-y: scroll;
  padding: 15px;
  background: #ffffff;
  //跟进样式
  .timeline-item{
    padding: 40px 0 14px 28px;
    div.huifu{
      background: rgba(0,0,0,0.03);
      border: 1px solid rgba(0,0,0,0.05);
      color: #666666;
      border-radius: 6px;
      padding:7px 14px;
      margin-top: 6px;
    }
    .title{
      font-family: 'gilroy-semibold';
    }
    &::after{
      top: 1.2em;
    }
  }
  div.traceStoreBoxModel{
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0,0,0,0.1);
    backdrop-filter: blur(5px);
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    div.traceStoreBox{
      justify-content: center;
      align-items: center;
      box-shadow: 0 0 1rem rgba(0, 0, 0, 0.2);
      padding: 30px 15px;
      background: #FFFFFF;
      div.xuanzeBox{
        display: flex;
        flex-direction: row;
        div{
          flex: 2;
          margin-right: 15px;
        }
        div.last{
          display: flex;
          align-items: center;
          margin: 0;
          flex: 1;
          div.form-group{
            margin: 0;
            .form-check{
              margin: 0;
            }
          }
        }
      }
      div.biaodanBox{
        .custom-file-label::after{
          content: '选择附件';
        }
      }
      div.textareaBox{
        textarea{
          height: 150px;
          border-radius: 5px;
        }
      }
      div.anniuBox{
        text-align: right;
      }
    }
  }
  span.tianjia{
    position: absolute;
    display: inline-block;
    width: 90px;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    margin-bottom: 20px;
    text-align: center;
    //line-height: 1.6em;
    box-shadow: 0 0 1rem rgba(0, 0, 0, 0.2);
  }
  .card{
    margin-bottom: 15px;
    .body{
      display: flex;
      .icon{
        float: none;
        width: 76px;
        height: 76px;
        margin-right: 20px;
      }
      .box{
        display: flex;
        flex-direction: column;
        justify-content: center;
        h5{
          margin: 0;
          margin-bottom: 8px;
        }
        .content{
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
      }

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/recruiment/trace.vue